import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium leading-6 text-gray-900 truncate"
}
const _hoisted_2 = ["id", "disabled", "value", "min", "max"]
const _hoisted_3 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}
const _hoisted_4 = {
  key: 1,
  class: "text-xs mt-1 text-red-600 sm:col-span-2 sm:items-end sm:col-start-2"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import { format, isValid, parse } from "date-fns";
import { useField } from "vee-validate";
import { computed, onMounted, PropType, watch } from "vue";

const dateFormat = "yyyy-MM-dd";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
  name: {
    type: String as PropType<string>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    required: false,
  },
  readonly: {
    type: Boolean as PropType<boolean>,
    required: false,
  },
  minDate: {
    type: Date as PropType<Date>,
    required: false,
  },
  maxDate: {
    type: Date as PropType<Date | null>,
    required: false,
  },
  inlineField: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
  date: {
    type: Date as PropType<Date | null>,
  },
  minWidth: {
    type: Number,
    required: false,
    default: 50,
  },
},
  setup(__props) {

const props = __props;

const { errorMessage, value, setValue } = useField<Date | null>(props.name);

onMounted(() => {
  if (props.maxDate && value.value && value.value > props.maxDate) {
    setValue(props.maxDate);
  } else if (props.date) {
    setValue(props.date ?? null);
  }
});

watch(
  () => props.date,
  (newDate) => {
    if (newDate) {
      setValue(new Date(newDate as Date));
    }
  },
);

const formattedValue = computed(() => (value.value ? format(value.value, dateFormat) : ""));

const setFromFormattedValue = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  const parsedValue = parse(value, dateFormat, new Date());
  setValue(isValid(parsedValue) ? parsedValue : null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'sm:grid sm:grid-cols-3 sm:gap-x-4 sm:items-center': __props.inlineField }),
      style: _normalizeStyle({ minWidth: `${__props.minWidth}px` })
    }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
          'relative mt-2 sm:mt-0 rounded-md shadow-sm',
          { 'sm:col-span-2 max-w-lg sm:max-w-xs': __props.inlineField },
        ])
      }, [
        _createElementVNode("input", {
          id: __props.name,
          type: "date",
          disabled: __props.readonly,
          class: _normalizeClass(["outline-none block w-full rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset focus:ring-2 focus:ring-inset text-xs min-h-8 sm:leading-6", 
            _unref(errorMessage)
              ? ['text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500 pr-9']
              : ['text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-orange-300 pr-3']
          ]),
          value: formattedValue.value,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (setFromFormattedValue($event))),
          min: props.minDate ? _unref(format)(props.minDate, dateFormat) : undefined,
          max: props.maxDate ? _unref(format)(props.maxDate, dateFormat) : undefined
        }, null, 42, _hoisted_2),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(ExclamationCircleIcon), {
                class: "h-5 w-5 text-red-500",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ], 6)
  ]))
}
}

})